export default "__VITE_ASSET__BhUFBUBb__"